// PB: Estimated Delivery – čte cut-off z data atributu .pb-ed[data-pb-cutoff]
(() => {
  const initialized = new WeakSet()

  const roots = () => document.querySelectorAll('.pb-ed')
  const hasWidgets = () => roots().length > 0

  // Lokalizace
  const LOCALE = 'cs-CZ'
  const TZ = 'Europe/Prague'
  const fmtWeekday = new Intl.DateTimeFormat(LOCALE, { weekday: 'long', timeZone: TZ })
  const formatDate = (d) => `${d.getDate()}. ${d.getMonth() + 1}.` // „17. 9.“

  const ALLOWED_CUTOFFS = ['11:00','12:00','13:00','14:00','15:00']
  const inStock = (v) => !!v && (v.available || v.inventory_policy === 'continue' || (v.inventory_quantity ?? 0) > 0)

  function parseHHMM(str) {
    const m = /^(\d{1,2}):(\d{2})$/.exec(String(str || ''))
    if (!m) return { h: 14, min: 0 }
    const h = Math.min(23, Math.max(0, parseInt(m[1], 10)))
    const min = Math.min(59, Math.max(0, parseInt(m[2], 10)))
    return { h, min }
  }

  // Vypočítá DISPATCH/DELIVERY podle aktivního cut-off
  function computeDeliveryInfo(activeCutoff) {
    const NOW = new Date()
    const { h, min } = parseHHMM(activeCutoff)

    function beforeCutoff(weekday, dateObj) {
      const nowMins = dateObj.getHours() * 60 + dateObj.getMinutes()
      const cutoffMins = h * 60 + min
      return nowMins < cutoffMins
    }

    function nextDispatch(now = NOW) {
      const d = new Date(now)
      const day = d.getDay()
      // Út(2)/Čt(4) – expedice dnes do cut-off
      if ((day === 2 || day === 4) && beforeCutoff(day, d)) return d
      // Jinak nejbližší Út/Čt
      let add
      if (day < 2) add = 2 - day
      else if (day < 4) add = 4 - day
      else add = (7 - day) + 2
      d.setDate(d.getDate() + add)
      return d
    }

    function nextDelivery(dispatchDate) {
      const dd = new Date(dispatchDate)
      while (dd.getDay() !== 3 && dd.getDay() !== 5) dd.setDate(dd.getDate() + 1) // st/pá
      return dd
    }

    const DISPATCH = nextDispatch(NOW)
    const DELIVERY = nextDelivery(DISPATCH)

    const TODAY0 = new Date(NOW); TODAY0.setHours(0,0,0,0)
    const DELIV0 = new Date(DELIVERY); DELIV0.setHours(0,0,0,0)
    const IS_TMR = Math.round((DELIV0 - TODAY0) / 86400000) === 1

    const wd = fmtWeekday.format(DELIVERY)        // např. „středa“
    const pred = (wd === 'středa' || wd === 'čtvrtek') ? 've' : 'v'
    const wdAkuz = (wd === 'středa') ? 'středu' : wd
    const df = formatDate(DELIVERY)

    return { IS_TMR, pred, wdAkuz, df }
  }

  function initEstimatedDelivery(root) {
    if (!root || initialized.has(root)) return
    initialized.add(root)

    // 1) cut-off z data atributu (fallback 14:00)
    let cutoff = (root.dataset.pbCutoff || root.getAttribute('data-pb-cutoff') || '14:00').trim()
    if (!ALLOWED_CUTOFFS.includes(cutoff)) cutoff = '14:00'

    // 2) předpočty dle cut-off
    const { IS_TMR, pred, wdAkuz, df } = computeDeliveryInfo(cutoff)

    const uid = root.id.replace('pb-ed-', '')
    const textEl = document.getElementById(`pb-ed-text-${uid}`)
    const dataEl = document.getElementById(`pb-ed-data-${uid}`)
    if (!textEl || !dataEl) return

    let product
    try { product = JSON.parse(dataEl.textContent || '{}') } catch { product = {} }
    const variants = Array.isArray(product?.variants) ? product.variants : []
    const VARS = {}
    for (let i = 0; i < variants.length; i++) VARS[String(variants[i].id)] = variants[i]

    const cache = {}
    function messageFor(variantId) {
      const key = String(variantId ?? '')
      if (cache[key]) return cache[key]
      const v = VARS[key]
      let msg
      if (!inStock(v)) {
        msg = 'Brzy opět skladem – do 14 dnů'
      } else {
        msg = IS_TMR ? `Skladem – doručíme již zítra ${df}` : `Skladem – doručíme již ${pred} ${wdAkuz} ${df}`
      }
      cache[key] = msg
      return msg
    }

    function updateByVariantId(variantId) {
      textEl.textContent = variantId ? messageFor(String(variantId)) : 'Brzy opět skladem – do 14 dnů'
    }

    const container = root.closest('.shopify-section') || document.body

    // Horizon event
    const sameProduct = (eProductId) => {
      const pidA = String(eProductId ?? '')
      const pidB = String(product?.id ?? '')
      return !pidA || !pidB || pidA === pidB
    }
    const onVariantUpdate = (e) => {
      if (!sameProduct(e?.detail?.data?.productId || e?.detail?.productId)) return
      updateByVariantId(e?.detail?.resource?.id)
    }
    container.addEventListener('variant:update', onVariantUpdate, { passive: true })

    // Fallback: input[name="id"]
    const form = container.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]')
    let idInput = form?.querySelector('input[name="id"]')
    const wireIdInput = (el) => {
      if (!el || el.dataset.pbEdWired === '1') return
      el.dataset.pbEdWired = '1'
      const onChange = () => updateByVariantId(el.value)
      el.addEventListener('change', onChange, { passive: true })
      new MutationObserver(onChange).observe(el, { attributes: true, attributeFilter: ['value'] })
    }

    // Inicializace
    const urlVariantId = new URLSearchParams(window.location.search).get('variant')
    if (urlVariantId) updateByVariantId(urlVariantId)
    else if (idInput?.value) updateByVariantId(idInput.value)
    else if (variants.length) updateByVariantId((variants.find(inStock) || variants[0]).id)

    wireIdInput(idInput)

    // Pozdější mount inputu
    const waitForIdInput = new MutationObserver(() => {
      if (idInput && idInput.isConnected) return
      idInput = (form || container).querySelector?.('form[action*="/cart/add"] input[name="id"]')
            || document.querySelector('form[action*="/cart/add"] input[name="id"]')
      if (idInput) { wireIdInput(idInput); if (idInput.value) updateByVariantId(idInput.value); waitForIdInput.disconnect() }
    })
    waitForIdInput.observe(container, { subtree: true, childList: true })

    ;(window.requestAnimationFrame || setTimeout)(() => {
      if (idInput?.value) updateByVariantId(idInput.value)
    }, 0)
  }

  function initAll() {
    const list = roots()
    if (!list.length) return
    list.forEach(initEstimatedDelivery)

    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (!m.addedNodes) continue
        m.addedNodes.forEach(n => {
          if (n.nodeType !== 1) return
          if (n.classList?.contains('pb-ed')) initEstimatedDelivery(n)
          n.querySelectorAll?.('.pb-ed').forEach(initEstimatedDelivery)
        })
      }
    })
    mo.observe(document.body, { childList: true, subtree: true })
  }

  const start = () => { if (hasWidgets()) initAll() }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true })
  else start()

  document.addEventListener('shopify:section:load', start)
  document.addEventListener('shopify:section:select', start)
})()